<template>
  <div class="py-3">
    <CardComponent @onClose="$emit('onClose')">
      <div class="px-5 py-3">
        <div class="flex justify-between items-center">
          <p class="text-sm font-bold text-greenPrimary">Detail Belum Dipesan</p>
          <SearchInput id="belum dipesan" @input="search" />
        </div>

        <LoadingLottie v-if="detailBelumDipesan.loading" />

        <div class="pt-3 overflow-x-auto relative rounded-lg">
          <div class="flex gap-1">
            <div class="basis-2/3">
              <div v-if="!detailBelumDipesan.loading">
                <table class="w-full text-sm text-left text-gray-500">
                  <thead>
                    <tr class="bg-gray-200">
                      <th
                        scope="row"
                        class="py-3 px-3 text-center border border-gray-300"
                      >
                        #
                      </th>
                      <th
                        scope="row"
                        class="py-3 px-3 border border-gray-300 text-center"
                      >
                        Feature Id
                      </th>
                      <th
                        scope="row"
                        class="py-3 px-3 text-center border border-gray-300"
                      >
                        Kode Petak
                      </th>
                      <th
                        scope="row"
                        class="py-3 px-3 text-center border border-gray-300"
                      >
                        Luas Area (m<sup>2</sup>)
                      </th>
                      <th
                        scope="row"
                        class="py-3 px-3 text-center border border-gray-300"
                      ></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      class="bg-white text-center"
                      v-for="(item, index) in detailBelumDipesan.rows"
                      :key="index"
                      :class="[
                        { 'hover:bg-lightGray': selected != item.feature_id },
                        { 'bg-gray100': selected == item.feature_id },
                      ]"
                    >
                      <td class="py-2 px-3 border border-gray-300">
                        {{ (page - 1) * limit + (index + 1) }}
                      </td>
                      <td class="py-2 px-3 border border-gray-300">
                        {{ item.properties.feature_id }}
                      </td>
                      <td class="py-2 px-3 border border-gray-300">
                        {{ item.properties.kode_petak }}
                      </td>
                      <td class="py-2 px-3 border border-gray-300 text-right">
                        {{ number(item.properties.luasmsquare) }}
                      </td>
                      <td class="py-2 px-3 border border-gray-300">
                        <div class="flex items-center justify-center">
                          <button
                            class="bg-blue-800 hover:bg-blue-900 rounded-full p-1"
                            @click="onClick(item)"
                          >
                            <IconEye color="white" size="w-3 h-3" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <PaginationComponent
                  v-model:length="length"
                  v-model:size="limit"
                  v-model:page="page"
                  @onSelectChange="changePage"
                />
              </div>
            </div>
            <div class="basis-1/3 flex-auto" v-show="!detailBelumDipesan.loading">
              <div
                class="flex flex-col"
                :class="detailBelumDipesan.rows?.length <= 10 ? 'h-[50vh]' : 'h-[98vh]'"
              >
                <div
                  class="py-3 px-3 text-sm text-gray-500 font-bold flex-none bg-[#D4DADC] border border-gray-300"
                >
                  Show Geofence
                </div>

                <div class="flex-auto">
                  <div
                    id="dash-map"
                    class="w-full h-full z-10 border border-gray-300"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CardComponent>
  </div>
</template>
<script>
import CardComponent from "@/components/CardWithCloseButton.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";
import LoadingLottie from "@/components/LoadingLottie.vue";
import IconEye from "@/components/icons/IconEye.vue";
import SearchInput from "@/components/SearchInput.vue";
import L from "leaflet";
import { useDashboardStore } from "@/store";
import { storeToRefs } from "pinia";
import { onMounted, ref } from "vue";

export default {
  components: {
    CardComponent,
    PaginationComponent,
    LoadingLottie,
    IconEye,
    SearchInput,
  },
  setup() {
    const dashboardStore = useDashboardStore();
    const { detailBelumDipesan } = storeToRefs(dashboardStore);

    const limit = ref(25);
    const offset = ref(0);
    const length = ref(0);
    const page = ref(1);
    const selected = ref(null);
    const q = ref(null);

    const dashmap = ref(null);
    const center = ref([-1.476796, 121.001893]);
    const zoom = ref(5);
    const geolayer = ref(null);

    const getDetail = async () => {
      await dashboardStore.getDetailBelumDipesan({});
      length.value = detailBelumDipesan.value.count;
    };

    const createMap = async () => {
      dashmap.value = L.map("dash-map", { zoomAnimation: false }).setView(
        center.value,
        zoom.value
      );
      L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png", {
        minZoom: 5,
        attribution: "Citra Satelite © 2025",
      }).addTo(dashmap.value);
    };

    onMounted(async () => {
      await getDetail();
      createMap();
    });

    const changePage = async (value) => {
      page.value = value;
      offset.value = (page.value - 1) * limit.value;

      let dataparams = { offset: offset.value };

      if (q.value != null || q.value != "") {
        dataparams = { ...dataparams, q: q.value };
      }

      await dashboardStore.getDetailBelumDipesan(dataparams);
      length.value = detailBelumDipesan.value.count;
    };

    const number = (number) => {
      var str = number.toString();
      if (str.indexOf("e-")) {
        var digits = str.split("e-")[0];
        var zeroes = str.split("e-")[1];

        if (zeroes != undefined) {
          if (zeroes <= 10) {
            var each = digits.split(".");
            var something = "0.";
            for (var i = 0; i < zeroes - 1; i++) {
              something += "0";
            }
            for (var j = 0; j < each.length; j++) {
              something = something + each[j];
            }
            something = parseFloat(something).toFixed(10);
            return something;
          } else {
            return 0;
          }
        } else {
          return number.toFixed(10);
        }
      }
    };

    const createGeofence = async (val) => {
      geolayer.value = L.geoJSON(val);
      dashmap.value.fitBounds(geolayer.value.getBounds());
      geolayer.value.addTo(dashmap.value);
    };

    const onClick = async (val) => {
      selected.value = val.properties.feature_id;
      if (dashmap.value.hasLayer(geolayer.value)) {
        await dashmap.value.removeLayer(geolayer.value);
      }

      await createGeofence(val);
    };

    const search = async (event) => {
      selected.value = null;
      dashmap.value.setView(center.value, zoom.value);
      offset.value = 0;
      page.value = 1;
      q.value = event.target.value;
      await dashboardStore.getDetailBelumDipesan({
        offset: offset.value,
        q: event.target.value,
      });
      length.value = detailBelumDipesan.value.count;
    };

    return {
      detailBelumDipesan,
      limit,
      page,
      length,
      selected,
      changePage,
      number,
      onClick,
      search,
    };
  },
};
</script>
<style></style>
